"use client";
import React from "react";
import UserInfo from "@/component/Auth/SignUp/UserInfo";

export default function Page() {
  return (
    <>
      <UserInfo />
    </>
  );
}